export default {
    filters: {
        title: "Filtros",
        removeFilter: "Eliminar filtro",
        filterIntensity: "Intensidad del filtro",
        duotone: {
            title: "Duotono",
            desert: "Desierto",
            peach: "Durazno",
            clash: "Choque",
            plum: "Ciruela",
            breezy: "Ventoso",
            deepBlue: "Azul profundo",
            frog: "Rana",
            sunset: "Atardecer",
        },
        blackAndWhite: {
            title: "B & W ",
            ad: "1920 D.C",
            greyed: "Envejecido",
            dusty: "Polvoriento",
            litho: "Litografía",
            sepia: "Sepia",
            weathered: "Desgastado",
            hardStuff: "Cosas difíciles",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Años 70 soleados",
            oldTimer: "Viejo cronista",
            inferno: "Infierno",
            snappy: "Rápido",
        },
        smooth: {
            title: "Suave",
            chestnut: "Castaño",
            softy: "Sensible",
            pebble: "Guijarro",
            moss: "Musgo",
            lemon: "Limón",
            greenGap: "Brecha verde",
        },
        cold: {
            title: "Frío",
            colla: "Colla",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zephira",
        },
        warm: {
            title: "Cálido",
            golden: "Dorado",
            lowFire: "Fuego bajo",
            sunrise: "Amanecer",
            flatBack: "Espalda plana",
            pumpkin: "Calabaza",
        },
    },
};
